<template>
  <div class="page mt-0">
    <h3 v-if="consultant">{{ consultant.last_name }} {{ consultant.name }} {{ consultant.middle_name }}</h3>
    <v-card v-if="resultPoll">
      <v-list>
        <v-container>
          <h4>{{ activePolls[0].name }}</h4>
        </v-container>
      </v-list>
      <v-list v-if="activePolls[0].description">
        <v-container>
          <pre>{{ activePolls[0].description }}</pre>
        </v-container>
      </v-list>
      <v-divider></v-divider>
      <v-list
        three-line
        subheader
      >
        <v-list-item>
          <v-list-item-content>
            <v-card
              v-for="(que, index) in activePolls[0].questions"
              :key="que.id"
            >
              <template>
                <v-container fluid>
                  <br>
                  <div>
                    <pre>{{ que.name }}</pre>
                  </div>
                  <br>
                  <div v-if="que.file">
                    <a :href="que.file" download target="_blank">
                      <v-chip>
                        <v-icon>mdi-eye-settings</v-icon>
                        читать файл
                      </v-chip>
                    </a>
                  </div>
                  <br>
                  <v-radio-group
                    v-model="resultsPoll.questions[index].answer"
                    row
                  >
                    <v-radio
                      v-for="ans in que.answers"
                      :key="ans.id"
                      :label="ans.name"
                      :value="{ id: ans.id, name: ans.name }"
                      @click="updateAllQuestions"
                    >
                    </v-radio>
                  </v-radio-group>
                  <br>
                  <br>
                </v-container>
              </template>
            </v-card>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-btn
              class="green"
              text
              :disabled="!AllQuestionsAnswer"
              @click="CreateResultFromUser"
            >
              Отправить ответы
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-card v-else>
      <h1>
        Голосований больше нет
      </h1>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'PollsEmails',
  data() {
    return {
      hash: this.$route.query['poll'] || null,
      consultant: null,
      polls: [],
      activePolls: [],
      resultPoll: false,
      resultsPoll: null,
      AllQuestionsAnswer: false
    }
  },
  beforeMount() {
    if (this.hash) {
      this.GET_CONSULTANT_BY_HASH_AND_GET_POLLS(this.hash).then(
        (response) => {
          this.consultant = response.consultant
          const { polls } = response

          if (polls.length) {
            this.activePolls = polls
            this.resultsPoll = {}
            for (const key in polls[0]) {
              const item = polls[0][key]
              let rezkey

              if (key === 'questions') {
                rezkey = []
                for (const que in item) {
                  rezkey[que] = { question: { id: item[que].id, name: item[que].name }, answer: 0 }
                }
              } else {
                rezkey = polls[0][key]
              }

              this.resultsPoll[key] = rezkey
            }
            this.resultPoll = true
          } else {
            this.resultPoll = false
          }
        }
      )
    }
  },
  methods: {
    ...mapActions('app', ['GET_CONSULTANT_BY_HASH_AND_GET_POLLS', 'CREATE_RESULT_FROM_USER']),
    _allQuestions() {
      if (!this.resultsPoll) {
        return false
      }
      for (const key in this.resultsPoll.questions) {
        if (!this.resultsPoll.questions[key].answer) {
          return false
        }
      }

      return true
    },
    updateAllQuestions() {
      this.AllQuestionsAnswer = this._allQuestions()
    },
    CreateResultFromUser() {
      this.CREATE_RESULT_FROM_USER(this.resultsPoll).then(
        (response) => {
          this.resultPoll = false
          this.resultsPoll = null
          this.AllQuestionsAnswer = false
          this.activePolls = []
        }
      )
    }
  }
}
</script>

<style scoped>

</style>
